<ng-container *showOnPlatformNarrow="Platform.Mobile">
  <div
    class="page-header__container"
    [class.compact]="isCompactHeaderVisible()"
    dataAttribute
    componentName="sticky-header-container"
  >
    <div
      class="page-header__sticky"
      [class.page-header__shadow]="isPageScrolled()"
      dataAttribute
      componentName="sticky-header"
    >
      @if (!isCompactHeaderVisible()) {
        <b2b-portal-header-user-info
          dataAttribute
          componentName="header-user-info"
          (makePaymentForBalance)="makePaymentForBalance()"
          (updateBalance)="updateBalanceInfo()"
        />
        <b2b-portal-header-search
          dataAttribute
          componentName="header-search"
          (makePaymentForBalance)="makePaymentForBalance()"
          (updateBalance)="updateBalanceInfo()"
        />
      } @else {
        <tiss-header-search-compact></tiss-header-search-compact>
      }
    </div>
  </div>

  <b2b-header-scroll-menu />
</ng-container>

<ng-container *showOnPlatformNarrow="[Platform.Tablet, Platform.Desktop]">
  <div
    class="page-header__container"
    dataAttribute
    componentName="sticky-header-container"
  >
    <div
      class="page-header__sticky"
      [class.page-header__shadow]="isPageScrolled()"
      dataAttribute
      componentName="sticky-header"
    >
      <b2b-portal-header-user-info
        dataAttribute
        componentName="header-user-info"
        (makePaymentForBalance)="makePaymentForBalance()"
        (updateBalance)="updateBalanceInfo()"
      />

      <b2b-portal-header-search
        dataAttribute
        componentName="header-search"
        (makePaymentForBalance)="makePaymentForBalance()"
        (updateBalance)="updateBalanceInfo()"
      />
    </div>
  </div>

  <b2b-header-scroll-menu />
</ng-container>
